import { FC } from 'react'
import styled from 'styled-components'
import { ImageAsset, TextEllipsis, TextLegacy } from '@/components/common'
import { LinkButton, PlainBorderButtonLegacy } from '@/components/common/buttons'
import { ReviewStarRating } from '@/components/common/etc'
import { NewCol } from '@/components/common/layouts/NewCol'
import { NewRow } from '@/components/common/layouts/NewRow'
import { ReviewImages } from '@/components/domains/etc'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { IModelReview } from '@/containers/models/modelReview'

type ListItemUserReviewProps = {
  review: IModelReview
}

const ListItemUserReview: FC<ListItemUserReviewProps> = ({ review }) => {
  const {
    id: reviewId,
    getProductName,
    getProductNumber,
    score,
    reviewBody,
    getWrittenDateFormat,
    isPhotoReview,
    reviewReviewImages,
  } = review

  return (
    <div>
      <Card>
        <LinkButton url={ROUTES.PRODUCTS.DETAIL.replace('[productId]', getProductNumber())}>
          <ProductNameRow align="center" gap="0.4rem">
            <NewCol>
              <TextLegacy weight="bold">구매 상품</TextLegacy>
            </NewCol>
            <NewCol flex="1">
              <TextEllipsis color="gray400" lineNumber={1}>
                {getProductName()}
              </TextEllipsis>
            </NewCol>
            <NewCol>
              <ImageAsset name="chevron-right" size={12} />
            </NewCol>
          </ProductNameRow>
        </LinkButton>

        <ScoreRow align="center" gap="0.4rem" style={{ marginTop: 1.4 }}>
          <NewCol>
            <ReviewStarRating rating={score} />
          </NewCol>
          <NewCol>
            <TextLegacy size={{ xs: 12, md: 14 }} color="gray400">
              {getWrittenDateFormat()}
            </TextLegacy>
          </NewCol>
        </ScoreRow>

        {isPhotoReview && (
          <ImageContainer>
            {/* @ts-ignore TODO typescript 오류 수정 필요 */}
            <ReviewImages images={reviewReviewImages} />
          </ImageContainer>
        )}
        <BodyRow>
          <TextLegacy size={{ xs: 13, md: 15 }}>{reviewBody}</TextLegacy>
        </BodyRow>

        <NewRow justify="flex-end">
          <LinkButton
            url={{
              pathname: ROUTES.MYPAGE.REVIEWS.EDIT,
              query: {
                reviewId,
              },
            }}
            routeType="replace"
          >
            <PlainBorderButtonLegacy text="리뷰 수정" height={40} />
          </LinkButton>
        </NewRow>
      </Card>
      <Divider />
    </div>
  )
}

const Card = styled.div`
  padding: 0px 20px;
  padding-bottom: 20px;
`
const ProductNameRow = styled(NewRow)`
  padding: 20px 0px;
  border-bottom: 1px solid ${GlobalColorEnum.Gray70};
`

const ScoreRow = styled(NewRow)`
  padding: 10px 0px;
`

const BodyRow = styled(NewRow)`
  padding-bottom: 10px;
`

const Divider = styled.div`
  height: 8px;
  background-color: ${(props) => props.theme.color.gray50};
`

const ImageContainer = styled.div`
  padding-bottom: 10px;
`

export default ListItemUserReview
